import React from 'react';
import { AnyRoute } from 'constants/routes';
import InlineText from 'global_elements/Text/InlineText';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import type { TFunction } from 'i18next';
import NavLinkWrapper from '../NavLinkWrapper';
import { NavLinkVariant } from '../NavLinkWrapper/variants';
import { GetNavText } from '../lib/navOptions';
import { getNavIcon } from '../lib/navIconOptions';
import { NavBarVariant } from '../NavBar/variants';

type SideNavLinkProps = {
  route: AnyRoute;
  navLinkVariant: NavLinkVariant;
  isUHS: boolean;
  t: TFunction<'translation', 'app'>;
  navBarVariant: NavBarVariant;
};

function SideNavLinkComponent(props: SideNavLinkProps): React.JSX.Element {
  return (
    <NavLinkWrapper key={`main-nav-${props.route}`} variant={props.navLinkVariant} route={props.route}>
      {props.navBarVariant === NavBarVariant.ICON ? (
        getNavIcon(props.route, Boolean(props.isUHS), props.t)
      ) : (
        <InlineText text={GetNavText(props.route, Boolean(props.isUHS), props.t)} fontColor={FontColors.BACKGROUND} fontSize={FontSizes.EXTRA_LARGE} />
      )}
    </NavLinkWrapper>
  );
}

export default SideNavLinkComponent;
